import { render, staticRenderFns } from "./TaskTemplateDetailListing.vue?vue&type=template&id=5e4ae472"
import script from "./TaskTemplateDetailListing.vue?vue&type=script&lang=js"
export * from "./TaskTemplateDetailListing.vue?vue&type=script&lang=js"
import style0 from "./TaskTemplateDetailListing.vue?vue&type=style&index=0&id=5e4ae472&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports